











import ECharts from 'vue-echarts'
import AbpBase from "@/lib/abpbase"
import {Component, Prop} from "vue-property-decorator"
import AddOrEdit from './addOrEdit.vue'
import {DeletePatPna, GetPatPnas} from "@/api/hd"

@Component({
	components: {AddOrEdit, ECharts}
})
export default class XX extends AbpBase {
	@Prop() patient: any
	addOrEditShow = false
	addOrEditData: any = {}
	loading = false
	tableData = []
	echartsData: any = {}

	mounted(){
		this.clearEchart()
		this.init()
	}

	columns = [{
		title: '时间',
		width: 200,
		render: (h: any, params: any) => {
			return h('span', this.formatDate(params.row.recordDate))
		}
	}, {
		title: 'SGA',
		width: 200,
		key: 'sga'
	}, {
		title: '说明',
		render: (h: any, params: any) => {
			return h('span', params.row.sga === 7 ? '营养正常' : params.row.sga >= 16 ? '重度营养不良' : '轻－中度营养不良')
		}
	}, {
		width: 180,
		title: '操作',
		render: (h: any, params: any) => {
			return h('div', [
				h('Button', {
					props: {
						type: 'primary'
					},
					style: {
						marginRight: '15px'
					},
					on: {
						click: () => {
							this.editOne(params.row)
						}
					}
				}, '编辑'),
				h('Button', {
					props: {
						type: 'error'
					},
					on: {
						click: () => {
							this.deleteOne(params.row)
						}
					}
				}, '删除'),
			])
		}
	}]

	addOne() {
		this.addOrEditData = {
			mode: 'add',
			patient: this.patient,
		}
		this.addOrEditShow = true
	}

	saveSuccess() {
		this.addOrEditShow = false
		this.init()
	}

	private async init() {
		let res = await GetPatPnas({patientId: this.patient.id})
		this.tableData = res.objects
		this.clearEchart()
		res.objects.forEach((item:any)=>{
			this.echartsData.xAxis.data.push(this.formatDate(item.recordDate))
			this.echartsData.series[0].data.push(item.sga)
		})
	}

	private editOne(row: any) {
		this.addOrEditData = {
			mode: 'edit',
			patient: this.patient,
			item: row
		}
		this.addOrEditShow = true
	}

	private async deleteOne(row: any) {
		this.$confirm('将删除该记录, 是否继续?', '提示', {
			confirmButtonText: '确定',
			cancelButtonText: '取消',
			type: 'warning'
		}).then(async () => {
			let res = await DeletePatPna({Id: row.id})
			this.init()
		}).catch(() => {

		});

	}

	private clearEchart() {
		this.echartsData = {
			xAxis: {
				type: 'category',
				data: []
			},
			yAxis: {
				type: 'value'
			},
			series: [{
				data: [],
				type: 'line'
			}]
		};
	}
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/electronicMedicalRecord/patient/parts/patPna/nutrition.vue